import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
  TableBodySkeleton,
} from '../../../common';

const SubscribersDataTable = ({
  data,
  isLoading,
  onEdit,
  onDelete,
  districts,
  LoadingComponent,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getDistrictName = (uuid) => {
    const district = districts.find((d) => d.uuid === uuid);
    return district?.name || 'Sin distrito';
  };

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((subscriber, index) => (
              <Box
                key={subscriber.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                  backgroundColor: 'white',
                }}
              >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Nombre
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {subscriber.first_name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Apellido
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {subscriber.last_name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      DNI
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {subscriber.dni}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Distrito
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {getDistrictName(subscriber.uuid_district)}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Dirección
                  </Typography>
                  <Typography variant="body2" fontWeight="medium" sx={{ mb: 2 }}>
                    {subscriber.address || 'Sin dirección'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(subscriber)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(subscriber.uuid)} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron suscriptores" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="subscribers table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="15%" wxs="20%">
              Nombre
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="20%">
              Apellido
            </HeadTableCell>
            <HeadTableCell wmd="12%" wxs="15%">
              DNI
            </HeadTableCell>
            <HeadTableCell wmd="25%" wxs="25%">
              Dirección
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Distrito
            </HeadTableCell>
            <HeadTableCell wmd="18%" wxs="5%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((subscriber, index) => (
              <TableRow key={subscriber.uuid || index}>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subscriber.first_name}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subscriber.last_name}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subscriber.dni}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subscriber.address || 'Sin dirección'}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {getDistrictName(subscriber.uuid_district)}
                </RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(subscriber)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(subscriber.uuid)} />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={6} message="No se encontraron suscriptores" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default SubscribersDataTable;
